import mapboxgl from 'mapbox-gl';
import {defineStore} from 'pinia';
import { Hyperlocal } from '~/api/models/hyperlocal.model';

export const useMapStore = defineStore('map', {
    state: () => {
        return {
            hyperlocals: [] as Hyperlocal[],
            zoom: null,
            bounds: null as mapboxgl.LngLatBounds,
            stations: [],
        }
    },

    getters: {
        hyperLocalInBounds(): Hyperlocal[] {

            if(!this.zoom || this.zoom < 6) {
                return [];
            }

            if(!this.bounds) {
                return [];
            }

            return this.hyperlocals.filter((hyperlocal: Hyperlocal) => {
                const [lonMin, latMin, lonMax, latMax] = hyperlocal.bbox.split(',').map(parseFloat);
                const sw = new mapboxgl.LngLat(lonMin, latMin);
                const ne = new mapboxgl.LngLat(lonMax, latMax);
                const cityBound = new mapboxgl.LngLatBounds(sw, ne);
                
                // check if bbox intersects
                return this.bounds.contains(cityBound.getNorthWest()) || 
                    this.bounds.contains(cityBound.getNorthEast()) || 
                    this.bounds.contains(cityBound.getSouthWest()) || 
                    this.bounds.contains(cityBound.getSouthEast()) ||
                    this.bounds.contains(cityBound.getCenter()) || 
                    cityBound.contains(this.bounds.getCenter())
            });
        }
    },

    actions: {
        fetchHyperlocals(): Promise<Hyperlocal[]> {
            if(this.hyperlocals && this.hyperlocals.length > 0) {
                return Promise.resolve(this.hyperlocals);
            }

            return this.$hyperlocalService.getAvailableHyperlocal().then((hyperlocals: Hyperlocal[]) => {
                return this.hyperlocals = hyperlocals;
            });
        },
    }
});